export default __webpack_public_path__ + "images/4790ac5edb968fec722f01b065d09b0c-header-pyxir.svg";